<template>
    <div class="text-sm font-medium" :class="props.textColorClass">
        © 2026
        <span class="font-bold uppercase tracking-tight" :class="props.textColorHighlight">{{ context.companyName }}</span>
        - {{ translate('cnpj', 'upper') }}: {{ context.companyCNPJ }}
    </div>
</template>

<script setup>
    import { translate } from '@/composables/translate';
    import { useContextStore } from '@/stores/context';
    import { defineProps } from 'vue';

    const props = defineProps({
        textColorClass: {
            type: String,
            default: 'text-chain',
        },
        textColorHighlight: {
            type: String,
            default: 'text-carrot',
        }
    });

    const context = useContextStore();
</script>